import { useMemo } from "react";

import { useEpOrganizationOrganizationList } from "@/hooks/use_ep_organization";
import { useQueryBillingTokenPackageList } from "@/queries";
import { useContextApp } from "@/screens/app/context/app";

export const useMePermissions = () => {
  const {
    state: {
      me,
      planLast,
      planActive,
      organizationId,
      isPersonalOrOwnOrganizationContext,
      recurringPaymentActive,
    },
  } = useContextApp();
  const { organizationList } = useEpOrganizationOrganizationList();
  const { data: tokenPackages } = useQueryBillingTokenPackageList();

  const organizationRole = useMemo(
    () =>
      (organizationId &&
        organizationList &&
        organizationList.find(
          (organization) => organization.id === organizationId,
        )?.role) ||
      null,
    [organizationId, organizationList],
  );

  const organizationPlanGroupId = useMemo(
    () =>
      (organizationId &&
        organizationList &&
        organizationList.find(
          (organization) => organization.id === organizationId,
        )?.owner?.active_plan_group_id) ||
      null,
    [organizationId, organizationList],
  );

  const planGroupId = isPersonalOrOwnOrganizationContext
    ? planActive?.group.id
    : organizationPlanGroupId;

  return {
    assistant:
      planActive?.is_trial ||
      (planGroupId &&
        ["pro", "s_business", "m_business", "l_business"].includes(
          planGroupId,
        )),

    advisor:
      planActive?.is_trial ||
      (planGroupId &&
        ["pro", "s_business", "m_business", "l_business"].includes(
          planGroupId,
        )),

    buy_watermark_slots:
      me.billing_policy_id !== "elama" && planActive?.id !== "canvas_2023",

    convert_plan:
      planActive &&
      !planActive.is_trial &&
      planActive.id !== "free_2022" &&
      me.billing_policy_id !== "elama" &&
      !recurringPaymentActive,

    polotno_unlimited: organizationId !== null || !!planActive,

    polotno_edit:
      organizationRole === null ||
      ["manager_v1", "editor_v1"].includes(organizationRole),

    renew_plan:
      me.billing_policy_id !== "elama" &&
      planLast &&
      !planLast.is_trial &&
      !["free", "free_foreign"].includes(planLast.id),

    reports_create: organizationRole === null,

    reports_edit: organizationRole === null,

    reports_delete: organizationRole === null,

    reports_accounts: organizationRole === null,

    repost_create:
      organizationRole === null || ["manager_v1"].includes(organizationRole),

    repost_edit:
      organizationRole === null ||
      ["manager_v1", "editor_v1"].includes(organizationRole),

    repost_delete:
      organizationRole === null || ["manager_v1"].includes(organizationRole),

    stream_create:
      organizationRole === null ||
      ["manager_v1", "editor_v1"].includes(organizationRole),

    stream_edit:
      organizationRole === null ||
      ["manager_v1", "editor_v1"].includes(organizationRole),

    stream_start:
      organizationRole === null ||
      ["manager_v1", "editor_v1"].includes(organizationRole),

    stream_delete:
      organizationRole === null ||
      ["manager_v1", "editor_v1"].includes(organizationRole),

    tokens_purchase:
      planActive?.group.id !== "canvas" && !!tokenPackages?.length,
  };
};
